import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsSkyMilesAnniversaryMocks: MicroMoments = {
  id: 'skymiles-anniversary',
  actionId: 'skymiles-anniversary-link',
  title: 'Happy Anniversary, Rocky!',
  description:
    'In Jan 2020, we welcomed you into the SkyMiles family. We appreciate your loyalty and are honored to have spent 3 year(s) flying together. Cheers to living the #SkyMilesLife and to more adventures to come!',
  action: {
    label: 'Explore Destinations',
    url: '/us/en/flight-deals/skymiles-award-deals'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/skymiles-anniversary.gif',
    alt: 'SkyMiles Anniversary Logo image',
    label: {
      title: '3',
      subtitle: 'years'
    }
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
